import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import formatCurrency from 'App/helpers/formatCurrency'

export default class Volume extends React.Component {
  static propTypes = {
    amount: PropTypes.number,
    mainCurrency: PropTypes.object
  }
  render() {
    const {amount, mainCurrency} = this.props
    return (
      <div className={styles.container}>
        <b> {formatCurrency(amount, mainCurrency, {code: true, short: true})}</b>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Desktop/Volume/index.js